<template>
	<div class="rounded-xl p-4 shadow bg-white">
		<paper-offers-edit-component
			:offer="offer"
			:active-futures="activeFutures"
			:form="form"
		/>

		<!--<template v-slot:other-buttons>-->
		<ui-button
			type="button"
			class="bg-red-500 rounded-lg shadow-sm py-2 px-4 font-medium text-white focus:ring-2 focus:ring-red-200"
			v-on:click="showDeleteModal = true"
			v-if="offer.id != null"
			>{{ __("Delete") }}</ui-button
		>
		<!--</template>-->

		<ui-modal
			v-if="showDeleteModal"
			:small="true"
			:key="'MODAL_' + showDeleteModal"
			v-on:close="showDeleteModal = false"
			ref="deleteModal"
			:confirm-label="__('Delete')"
			v-on:confirm="deleteOffer()"
			>{{ __("Do you want to delete the listing?") }}</ui-modal
		>
		<ui-button
			:disabled="submitButtonDisabled"
			v-on:click="submitForm()"
			:label="labels.submit"
		/>
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		trade: {
			type: String,
			required: true,
		},
		offer: {
			type: Object,
			required: false,
		},
		filterOptions: {
			type: Object,
			required: false,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	data() {
		let action = this.offer.id ? "edit" : "create";
		let labels = {
				buy: {
					create: {
						submit: this.__("Create new purchase listing"),
					},
					edit: {
						submit: this.__("Update purchase listing"),
					},
				},
				sell: {
					create: {
						submit: this.__("Create new sales listing"),
					},
					edit: {
						submit: this.__("Update sales listing"),
					},
				},
			},
			defaultOffer = {
				type: "OFFER",
				trade: this.trade.toUpperCase(),
				product: {
					origin: "EU",
					type: null,
					grade: null,
					harvest: null,
				},
				quality: {
					paper_fixed: null,
				},
				location: {
					hub: "",
					mode: "DAP",
				},
				qty: {
					mt: null,
				},
				price: {
					type: "FLAT",
					mt: null,
					basis: null,
					commodity_future_id: null,
				},
				date: {
					type: "MONTH",
					month_from: null,
					month_to: null,
				},
			},
			//Vue.observable(action == 'edit' ? this.offer : defaultOffer)
			form = action == "edit" ? this.offer : defaultOffer;
		return {
			test: null,
			action: action,
			labels: labels[this.trade][action],
			showDeleteModal: false, // TODO delete should be done through inertia
			form: Vue.observable(this.$inertia.form(form)),
			submitButtonDisabled: false,
		};
	},
	created() {
		// REMOVE DEAD CODE
		// if create, fill in defaults from filter where possible
		if (this.action == "create") {
			this.form.location.hub = this.getUniqueSelectedFilterId("locationHubs");
			this.form.product.grade = this.getUniqueSelectedFilterId("productGrades");

			let productHarvest = this.getUniqueSelectedFilterId("productYears") * 1;
			if (productHarvest > 0) {
				this.form.product.harvest = productHarvest;
			}
			if (
				productHarvest > 0 &&
				["FRANKOCIF_HAMBURG", "FRANKOCIF_ROSTOCK"].includes(
					this.form.location.hub
				)
			) {
				this.form.date.type = "BASIS";
				this.form.date.month_from = `${productHarvest}-09-01`;
				this.form.date.month_to = `${productHarvest + 1}-05-01`;
			}
		}
	},
	methods: {
		afterSubmit(response) {
			console.log("KTHXBYE", response);
			//this.$bus.$emit('paper-update', response);
			this.$emit("close");
		},
		getUniqueSelectedFilterId(key) {
			let v = this.filterOptions[key].filter((f) => f.checked == true);
			if (key == "productGrades") {
				this.test = v;
			}
			return v.length == 1 ? v[0].id : null;
		},
		async deleteOffer() {
			let endpoint =
				window.baseUrl +
				"/paper/offer_" +
				this.offer.trade.toLowerCase() +
				"/" +
				this.offer.id;
			// response = await axios.delete(endpoint);
			this.$inertia.delete(endpoint);
			this.showDeleteModal = false;
			//this.$bus.$emit('paper-update', response.data);
			this.$emit("close");
		},
		submit() {
			let form = this.form;
			this.form.post(window.baseUrl + "/paper", {
				onError() {
					console.log("ERROR", form.errors);
				},
			});
		},
		async submitForm() {
			let endpoint = this.$page.url,
				method = "patch", // always use patch for storing, even when creating
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
					that.$emit("close");
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
	},
};
</script>
